export default "__VITE_ASSET__CAoji0uF__";